import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';

import type { Chat, User } from '@/shared/api';

const initStore = () => {
  const map = ref<Map<User['id'], Map<Chat['id'], boolean>>>(new Map());

  const setUserTyping = (userId: User['id'], chatId: Chat['id'], newVal: boolean): void => {
    if (!map.value.get(userId)) {
      map.value.set(userId, new Map());
    }

    const userMap = map.value.get(userId)!;
    userMap.set(chatId, newVal);
  };

  const getUserTyping = (userId: User['id'], chatId: Chat['id']): boolean =>
    (map.value.get(userId) ?? new Map()).get(chatId) ?? false;

  return { allData: readonly(map), setUserTyping, getUserTyping };
};

const useUsersTypingStore = defineStore('users-typing', initStore);

export { useUsersTypingStore };
